import { render } from "./BonusRecord.vue?vue&type=template&id=1db86df8"
import script from "./BonusRecord.vue?vue&type=script&lang=js"
export * from "./BonusRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__